import React from 'react';

const InfoCard = () => {
  return (
    <div elevation={3} style={{ textAlign: 'center', padding: '0 10%' }}>
      Money go up 📈 = Good <br/>
      Money go down 📉 = Bad 

    </div>
  );
};

export default InfoCard;